import React from 'react';

/**
 * Componente que envolve os slots de tempo do calendário
 * Permite destacar slots específicos (como horários comerciais)
 * 
 * @param {Object} props - Propriedades do componente
 * @param {JSX.Element} props.children - Conteúdo do slot
 * @param {Object} props.value - Dados do slot (hora)
 * @returns {JSX.Element} - Elemento React
 */
const TimelineTimeSlotWrapper = ({ children, value }) => {
  // Verificar se o slot representa o início de uma hora comercial
  const isBusinessHour = value && 
    value.getHours() >= 8 && 
    value.getHours() <= 19 && 
    value.getMinutes() === 0;
  
  // Determinar classes com base no estado
  let wrapperClass = '';
  
  if (isBusinessHour) {
    wrapperClass = 'business-hour-slot';
  }
  
  // Retornar o wrapper com as classes apropriadas
  return (
    <div className={wrapperClass}>
      {children}
    </div>
  );
};

export default TimelineTimeSlotWrapper; 